(() => {
  const state = {
    mode: 'campaign',
    scheduled: false,
    campaignImages: new WeakMap(),
    studioImages: new WeakMap(),
    studioImageBySlideshow: new WeakMap(),
  };

  const imageAttributes = [
    'src',
    'srcset',
    'sizes',
    'alt',
    'width',
    'height',
    'loading',
    'fetchpriority',
    'style',
    'data_max_resolution',
  ];

  const readAttributes = (image) => {
    const attributes = {};
    imageAttributes.forEach((name) => {
      attributes[name] = image.getAttribute(name);
    });
    return attributes;
  };

  const writeAttributes = (image, attributes) => {
    imageAttributes.forEach((name) => {
      const value = attributes[name];
      if (value == null) image.removeAttribute(name);
      else image.setAttribute(name, value);
    });
  };

  const syncControls = (announce = false) => {
    const isStudio = state.mode === 'studio';
    const currentLabel = isStudio ? 'Studio' : 'Campaign';
    const nextLabel = isStudio ? 'Campaign' : 'Studio';

    document.querySelectorAll('collection-image-toggle').forEach((toggle) => {
      const button = toggle.querySelector('button');
      const label = toggle.querySelector('[data-image-mode-label]');
      const status = toggle.querySelector('[data-image-mode-status]');

      if (button) {
        button.setAttribute('aria-pressed', String(isStudio));
        button.setAttribute(
          'aria-label',
          `Showing ${currentLabel} photography. Switch to ${nextLabel} photography.`
        );
      }

      if (label) label.textContent = currentLabel;
      if (status && announce) status.textContent = `${currentLabel} photography selected.`;
    });
  };

  const applyMode = () => {
    document.querySelectorAll('results-list .product-grid__item slideshow-component').forEach((slideshow) => {
      const slides = Array.from(slideshow.querySelectorAll('slideshow-slide'));
      const campaignSlide = slides[0];
      const campaignImage = campaignSlide?.querySelector('img');
      if (!campaignSlide || !campaignImage) return;

      if (!state.campaignImages.has(campaignImage)) {
        state.campaignImages.set(campaignImage, readAttributes(campaignImage));
      }

      let studioImage = state.studioImageBySlideshow.get(slideshow);
      if (!studioImage) {
        studioImage = slides
          .map((slide) => slide.querySelector('img'))
          .find((image) => image && (image.getAttribute('alt') || '').toLowerCase().includes('ecomm'));

        if (studioImage) {
          state.studioImageBySlideshow.set(slideshow, studioImage);
          if (studioImage !== campaignImage && !state.studioImages.has(studioImage)) {
            state.studioImages.set(studioImage, readAttributes(studioImage));
          }
        }
      }

      const campaignAttributes = state.campaignImages.get(campaignImage);
      const studioAttributes = studioImage && state.studioImages.get(studioImage);

      if (state.mode === 'studio') {
        if (studioImage && studioImage !== campaignImage && studioAttributes) {
          writeAttributes(campaignImage, studioAttributes);
          writeAttributes(studioImage, campaignAttributes);
        }

        campaignSlide.classList.toggle(
          'collection-image-mode--studio-video',
          Boolean(studioImage) && campaignSlide.classList.contains('product-media-container--video')
        );
      } else {
        writeAttributes(campaignImage, campaignAttributes);
        if (studioImage && studioImage !== campaignImage && studioAttributes) {
          writeAttributes(studioImage, studioAttributes);
        }
        campaignSlide.classList.remove('collection-image-mode--studio-video');
      }

      const campaignSlideId = campaignSlide.getAttribute('slide-id');
      if (!campaignSlideId) return;

      if (typeof slideshow.select === 'function') {
        slideshow.select({ id: campaignSlideId }, undefined, { animate: false });
      } else {
        slideshow.setAttribute('initial-slide', '0');
      }
    });
  };

  const schedule = () => {
    if (state.scheduled) return;
    state.scheduled = true;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        state.scheduled = false;
        applyMode();
      });
    });
  };

  if (!customElements.get('collection-image-toggle')) {
    customElements.define(
      'collection-image-toggle',
      class CollectionImageToggle extends HTMLElement {
        connectedCallback() {
          const button = this.querySelector('button');
          if (!button || button.dataset.imageModeReady === 'true') return;

          button.dataset.imageModeReady = 'true';
          button.addEventListener('click', () => {
            state.mode = state.mode === 'campaign' ? 'studio' : 'campaign';
            syncControls(true);
            schedule();
          });

          syncControls();
        }
      }
    );
  }

  const results = document.querySelector('results-list');
  if (results) {
    new MutationObserver(() => {
      if (state.mode === 'studio') schedule();
    }).observe(results, { childList: true, subtree: true });
  }
})();
